"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = global.WebSocket || global.MozWebSocket;
//# sourceMappingURL=ws-browser.js.map